import { ChevronLeft, ChevronRight } from "lucide-react";

/* Deux modes : décalage (page N sur M, sauts directs) et curseur (précédent /
   suivant seulement — un curseur n'autorise pas le saut de page). */

function pageList(page, pages) {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const out = [1];
  const from = Math.max(2, page - 1);
  const to = Math.min(pages - 1, page + 1);
  if (from > 2) out.push("…");
  for (let i = from; i <= to; i += 1) out.push(i);
  if (to < pages - 1) out.push("…");
  out.push(pages);
  return out;
}

export default function Pagination({
  mode = "offset",
  page = 1,
  pageSize = 50,
  total = 0,
  pageSizes = [25, 50, 100],
  onPageChange,
  onPageSizeChange,
  hasNext = false,
  hasPrev = false,
  onNext,
  onPrev,
  loading = false,
  countLabel,
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  return (
    <div className="adm-pag" data-testid="pagination">
      <span>
        {countLabel || (mode === "cursor"
          ? `${total} élément${total > 1 ? "s" : ""} sur cette page`
          : `${from}–${to} sur ${total}`)}
      </span>

      {onPageSizeChange && (
        <label style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <span className="adm-sr">Éléments par page</span>
          <select
            value={pageSize}
            onChange={e => onPageSizeChange(Number(e.target.value))}
            aria-label="Éléments par page"
            data-testid="page-size"
          >
            {pageSizes.map(size => <option key={size} value={size}>{size} / page</option>)}
          </select>
        </label>
      )}

      <nav className="adm-pag-pages" aria-label="Pagination">
        <button
          type="button"
          disabled={loading || (mode === "cursor" ? !hasPrev : page <= 1)}
          onClick={() => (mode === "cursor" ? onPrev?.() : onPageChange?.(page - 1))}
          aria-label="Page précédente"
          data-testid="page-prev"
        >
          <ChevronLeft size={14} />
        </button>

        {mode === "offset"
          ? pageList(page, pages).map((item, i) => (item === "…"
            ? <span key={`gap-${i}`}>…</span>
            : (
              <button
                key={item}
                type="button"
                className={item === page ? "is-current" : undefined}
                aria-current={item === page ? "page" : undefined}
                onClick={() => onPageChange?.(item)}
                data-testid={`page-${item}`}
              >
                {item}
              </button>
            )))
          : <span style={{ padding: "0 6px" }}>Page {page}</span>}

        <button
          type="button"
          disabled={loading || (mode === "cursor" ? !hasNext : page >= pages)}
          onClick={() => (mode === "cursor" ? onNext?.() : onPageChange?.(page + 1))}
          aria-label="Page suivante"
          data-testid="page-next"
        >
          <ChevronRight size={14} />
        </button>
      </nav>
    </div>
  );
}
